export default __webpack_public_path__ + "static/media/brde.deb81f79.jpg";